import { OrganisationDetailResponse, UpdateOrganisationDetailsRequest } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { OrganisationDetail, organisationDetailFromResponse } from './organisationDetails';

export interface UpdateOrganisationDetailsPayload {
  organisationDisplayName: string;
  emailDomains?: string[];
  liftDataIds?: number[];
  isCampaignEnabled?: boolean;
}

export default class UpdateOrganisationDetails extends BaseAdapter<OrganisationDetailResponse> {
  rawResponse: OrganisationDetailResponse;

  modifiedRequest: UpdateOrganisationDetailsRequest;

  async adaptResponse(
    payload: UpdateOrganisationDetailsPayload,
  ): Promise<OrganisationDetail> {
    await this.fetchApiResponse(
      '/api/admin/organisation/details',
      HTTPMethod.Patch,
      this.adaptRequest(payload)
    );
    return organisationDetailFromResponse(this.rawResponse);
  }

  adaptRequest(payload: UpdateOrganisationDetailsPayload): UpdateOrganisationDetailsRequest {
    this.modifiedRequest = {
      organisation_display_name: payload.organisationDisplayName,
      email_domains: payload.emailDomains,
      lift_data_ids: payload.liftDataIds,
      is_campaign_enabled: payload.isCampaignEnabled,
    };
    return this.modifiedRequest;
  }
}
